import {useQuery} from "react-query";
import {useParams} from "react-router-dom";
import api from "../services/api";
import queryClient from "../services/queryClient";
import {useRecoilValue} from "recoil";
import {spaceIdState} from "../state/spaceState";

const fetchPages = (timing) => {
    return api.get(`/timings/${timing}/pages`).then(response => response.data && response.data.data);
}

const useFetchPages = () => {
    const id = useRecoilValue(spaceIdState);

    return useQuery([id, 'pages'], () => fetchPages(id), {
        staleTime: Infinity,
        enabled: !!id,
        onSuccess: data => {
            if(!data) {
                return;
            }

            data.forEach(item => queryClient.setQueryData([id, 'pages', item.slug], item));
        }
    });
};

export default useFetchPages;
